// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de669710","455":"23b446ce"}[chunkId] + ".chunk.js";
};